import {
  Select,
  SelectOption,
  SelectProps,
} from '@ui/Select';

import { useCitySelectQuery } from './graphql.v3.generated';

export type CitySelectOption = SelectOption<number>;

type CitySelectContainerProps = Omit<SelectProps<CitySelectOption>, 'options'>;

export const CitySelectContainer: React.FC<CitySelectContainerProps> = (props) => {
  const { data } = useCitySelectQuery({
    context: { batch: true },
  });

  return (
    <Select
      options={
        data?.filterCity?.length
          ? data.filterCity.map(({ id, name }) => ({ value: id, label: name }))
          : []
      }
      {...props}
    />
  );
};
